import * as firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'
import { config } from './config'

const app = firebase.initializeApp(config)

// Databases
const settings = { timestampsInSnapshots: true }

export const db = app.firestore()
db.settings( settings )

export const users = db.collection('users')
export const categories = db.collection('categories')

// Auth
export const auth = app.auth()

// Storage
export const storageFiles = app.storage().ref()



// WEBPACK FOOTER //
// ./src/firebase/index.js